import React, { useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

//UI
import { Row, Col, message } from "antd";
import { RequiredFormLabel } from "../RequiredFormLabel/RequiredFormLabel";
import { Input } from "../../Common/Input";
import { Button, ButtonPrimary } from "../../Common/Button";
import { Form } from "@ant-design/compatible";

//Processing
import {
  useUpdateCorporateContact,
  useCreateCorporateContact,
} from "../../../hooks/Onboarding/onboarding-corporate-contacts.hooks";
import { RECORD_OPERATIONS } from "../../../utils/onboarding-helper";

import {
  corporateContactCreateSchema,
  corporateContactUpdateSchema,
} from "../../../schema/onboarding-customer.schema";

const CorporateUserForm = (props) => {
  const { closeDrawer, operationData, operation, customer } = props;

  const history = useHistory();

  const currentCorporateContactSchema = useMemo(() => {
    switch (operation) {
      case RECORD_OPERATIONS.ADD:
        return corporateContactCreateSchema;
      default:
        return corporateContactUpdateSchema;
    }
  }, [operation]);

  const {
    handleSubmit,
    reset,
    clearErrors,
    formState: { errors },
    control,
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(currentCorporateContactSchema),
  });

  const { mutate: updateCorporateContact } = useUpdateCorporateContact({
    onSuccess: () => {
      message.success("Corporate contact successfully edited");
      history.push(
        `/onboarding/users?customer=${customer}&queryTab=corporate_user`,
      );
    },
    onError: (error) => {
      message.error(error.response?.data?.message ?? "Server Error");
    },
  });

  const { mutate: createCorporateContact } = useCreateCorporateContact({});

  const formFirstStepSubmit = async (submitData) => {
    console.log("Form1", submitData);
    if (operation === RECORD_OPERATIONS.EDIT) {
      await updateCorporateContact(submitData);
    } else {
      if (customer !== undefined) {
        submitData.customer_id = customer;
        await createCorporateContact(submitData);
      }
      message.error("Please select a customer");
      closeDrawer();
    }
  };

  useEffect(() => {
    clearErrors();
    reset({});
    if (operation === RECORD_OPERATIONS.EDIT) {
      reset({
        _id: operationData._id,
        first_name: operationData.first_name,
        last_name: operationData.last_name,
        phone_number: operationData.phone_number,
        email: operationData.email,
        property_id: operationData.property_id,
        customer_id: operationData.customer_id,
        status: operationData.status,
      });
    }
  }, [operation, operationData]);

  return (
    <div>
      <form onSubmit={handleSubmit(formFirstStepSubmit)} layout="vertical">
        <Row>
          <Form.Item
            label={<RequiredFormLabel value="Corporate Contact First Name" />}
            help={errors?.first_name?.message}
            validateStatus={errors?.first_name ? "error" : ""}
          >
            <Controller
              control={control}
              name="first_name"
              render={({ field: { onChange, value } }) => (
                <Input
                  value={value}
                  onChange={onChange}
                  placeholder="Corporate Contact First Name"
                />
              )}
            ></Controller>
          </Form.Item>
          <Form.Item
            label={<RequiredFormLabel value="Corporate Contact Last Name" />}
            help={errors?.last_name?.message}
            validateStatus={errors?.last_name ? "error" : ""}
          >
            <Controller
              control={control}
              name="last_name"
              render={({ field: { onChange, value } }) => (
                <Input
                  value={value}
                  onChange={onChange}
                  placeholder="Corporate Contact Last Name"
                />
              )}
            ></Controller>
          </Form.Item>
          <Form.Item
            label={<RequiredFormLabel value="Corporate Contact Phone Number" />}
            help={errors?.phone_number?.message}
            validateStatus={errors?.phone_number ? "error" : ""}
          >
            <Controller
              control={control}
              name="phone_number"
              render={({ field: { onChange, value } }) => (
                <Input
                  value={value}
                  onChange={onChange}
                  placeholder="Corporate Contact Phone Number"
                />
              )}
            ></Controller>
          </Form.Item>
          <Form.Item
            label={<RequiredFormLabel value="Corporate Contact Email" />}
            help={errors?.email?.message}
            validateStatus={errors?.email ? "error" : ""}
          >
            <Controller
              control={control}
              name="email"
              render={({ field: { onChange, value } }) => (
                <Input
                  value={value}
                  onChange={onChange}
                  placeholder="Corporate Contact Email"
                  disabled={operation == RECORD_OPERATIONS.EDIT}
                />
              )}
            ></Controller>
          </Form.Item>
        </Row>
        <Row>
          <Col span={12}>
            <Button
              style={{ width: "150px" }}
              htmlType="button"
              onClick={() => {
                reset({});
                closeDrawer();
              }}
            >
              Cancel
            </Button>
          </Col>
          <Col span={12}>
            <ButtonPrimary style={{ width: "150px" }} htmlType="submit">
              Save
            </ButtonPrimary>
          </Col>
        </Row>
      </form>
    </div>
  );
};

export default CorporateUserForm;
